import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/** Saludo para empleados: los administradores van al panel gerencial. */
export const bienvenidaEmpleadoGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.esRolAdministrador()) return router.createUrlTree(['/app/dashboard']);
  return true;
};
